import { h } from 'preact';
import { useState, useEffect, useRef } from 'preact/hooks';
import Panel from 'utils/panel';
import Icon from 'utils/icon';
import { formatMoney } from 'utils/storefront/format-resource';
import Image from "utils/image";
import { withCartContext } from './cart-context';

const Gift = ({
  cart,
  activeProduct,
  line,
  openEl,
  giftWrappingProduct,
  giftWrappingQuantity,
}) => {

  if (!giftWrappingProduct.enableGiftWrapping ||
    !giftWrappingProduct.id) {
    return null;
  }
  if (
    activeProduct?.allowGiftMessage?.value !== '1' &&
    activeProduct?.allowGiftWrap?.value !== '1'
  ) return null;
  const initialLineItemProperties = { ...line.properties };
  const [triggerEl, setTriggerEl] = useState(null);

  const initialGiftMessage = initialLineItemProperties["Gift Message"] || '';
  const initialGiftMessageChecked =
    !!initialLineItemProperties._gift_message_checked;

  const [giftMessageError,setGiftMessageError] = useState(false);

  const [giftMessage, setGiftMessage] = useState(initialGiftMessage);
  const [giftMessageChecked, setGiftMessageChecked] = useState(
    initialGiftMessageChecked
  );
  const giftWrappingProductFlag =
    (!activeProduct?.allowGiftWrap || activeProduct?.allowGiftWrap?.value === '1') &&
    line?.properties?._gift_wrapping;
  const [giftWrappingChecked, setGiftWrappingChecked] = useState(
    giftWrappingProductFlag
  );
  const [isFocusable,setIsFocusable] = useState(false);
  const lastGiftTriggerRef = useRef(null);

  useEffect(() => {
    if (openEl?.current) {
        setTriggerEl(openEl.current);
        lastGiftTriggerRef.current = openEl.current;
    }
}, [openEl?.current]);

  useEffect(() => {
    setPanelTriggers((prevTriggers) => ({
      ...prevTriggers,
      openTriggerEl: triggerEl,
    }));
  }, [triggerEl]);

  const closeTriggerEl = useRef(null);
  const backIconRef = useRef(null);
  const applyButtonRef = useRef(null);
  const [panelTriggers, setPanelTriggers] = useState({
    openTriggerEl: triggerEl,
    closeTriggerEl: null,
  });

  useEffect(() => {
    if (!closeTriggerEl.current || !applyButtonRef.current) return;
    setPanelTriggers((value) => ({
      ...value,
      // eslint-disable-next-line max-len
      closeTriggerEl: [closeTriggerEl.current, backIconRef.current, applyButtonRef.current],
    }));
}, [closeTriggerEl.current, backIconRef.current, applyButtonRef.current]);

  const updateLineItems = (lineProperties) => {
    const payload =
    {
      id: line.key,
      attributes: lineProperties,
      quantity: line.quantity,
    };

    return cart.updateAttributes(payload);
  };

  const closeGiftPanel = () => {
    setTimeout(() => {
      requestAnimationFrame(() => {
        if(lastGiftTriggerRef.current && typeof lastGiftTriggerRef.current.focus === 'function') {
          lastGiftTriggerRef.current.focus();
        } 
      });
    }, 100);
  };

  const handleApplyClick = () => {
    const lineItemPropertiesUpdate = {};
    const giftProductPayload = []
    const giftProductPayloadObject = {}

    // Iterate over all keys in line.properties
    Object.keys(line?.properties || {}).forEach(key => {
      let value = line?.properties[key];
      if (typeof value === 'string') value = value.trim();
      if (value !== '') {
        lineItemPropertiesUpdate[key] = line.properties[key];
      }
    });

    if (giftMessageChecked && giftMessage) {
      lineItemPropertiesUpdate["Gift Message"] = giftMessage;
      lineItemPropertiesUpdate._gift_message_checked = true;
    } else if (!giftMessageChecked) {
      lineItemPropertiesUpdate["Gift Message"] = undefined;
      lineItemPropertiesUpdate._gift_message_checked = undefined;
    }

    if (giftWrappingChecked) {
      lineItemPropertiesUpdate._gift_wrapping = true;
      giftProductPayloadObject.id = giftWrappingProduct.id
      giftProductPayloadObject.merchandiseId = giftWrappingProduct.id
      giftProductPayloadObject.quantity = line.quantity;
      const attributes = [
        { key: "_GiftProduct", value: true }
      ];
      giftProductPayloadObject.attributes = attributes;
      giftProductPayload.push(giftProductPayloadObject);
      if (line?.properties?._gift_wrapping !== true) {
        setTimeout(() => {
          cart.add(giftProductPayload);
        }, 500)
      }
    } else if (
      !giftWrappingChecked
      && line?.properties?._gift_wrapping === true
    ) {
      lineItemPropertiesUpdate._gift_wrapping = undefined;
      const giftWrappingQuantityCalculated =
        giftWrappingQuantity - line.quantity;
      const payload = []
      payload.push(
        {
          id: giftWrappingProduct.id.split('/').splice(-1)[0],
          quantity: giftWrappingQuantityCalculated
        }
      )
      setTimeout(() => {
        cart.update(payload);
      }, 500)
    }

    updateLineItems(lineItemPropertiesUpdate);
    closeGiftPanel();
  };


  const toggleGiftMessage = (e) => {
    if (e.type === 'click' || 
      (e.type === 'keydown' && 
      (e.key === ' ' || 
      e.key === 'Enter'))) {
        e.preventDefault();
        e.stopPropagation();
        setGiftMessageChecked(!giftMessageChecked);
    }
  };

  const toggleGiftWrapping = (e) => {
    if (e.type === 'click' || 
      (e.type === 'keydown' && 
      (e.key === ' ' || 
      e.key === 'Enter'))) {
        e.preventDefault();
        e.stopPropagation();
        setGiftWrappingChecked(!giftWrappingChecked);
    }
    
  }

  const handleGiftMessageChange = (e) => {
    const pattern = /[^a-zA-Z0-9 !@#$%^&*()_+\-=[\]{};:'",.<>?/\\|`~]/;
    const inputValue = e.target.value;
    const isValid = !pattern.test(inputValue);

    setGiftMessageError(!isValid)

    setGiftMessageChecked(true)
    if (inputValue.length <= 300) {
      setGiftMessage(inputValue);
    }
    if (inputValue.length === 0) {
      setGiftMessageChecked(false)
    }
  }

  return (
    <Panel overlay={true} overlayId='gift' overlayOpacity='opacity-0' triggers={panelTriggers} defaultOpen={false} defaultFocus=".default-focus-element" context="gift" childrenVisible={setIsFocusable}>
      <div className='h-[100dvh]' data-gift>
        <div className="sticky flex items-center justify-between px-3.5 py-5 border-b border-grey-3">
          <div className="flex gap-2.5 items-center" ref={backIconRef}>
            <button type="button" className="rotate-180 mt-0.5" aria-label={window.TMW.Strings.cart.giftOptions} 
              tabIndex={isFocusable?'0':'-1'} 
              onClick={closeGiftPanel}>
              <Icon name="carret" />
            </button>
            <p className="utility-1 uppercase font-medium">
              {window.TMW.Strings.cart.giftOptions}
            </p>
          </div>
          <button type="button" ref={closeTriggerEl} 
            tabIndex={isFocusable?'0':'-1'} 
            onClick={closeGiftPanel}
            aria-label='Gift option close'>
            <Icon name="close" />
            <span className="sr-only">
              {window.TMW.Strings.cart.close}
            </span>
          </button>
        </div>
        <div className={`h-full ${!isFocusable ? 'hidden' : ''}`}>
        <div className='pt-8 px-5'>
          {activeProduct?.allowGiftMessage?.value === '1' &&
            <div className='flex flex-col border-b border-grey-3 pb-6 gap-4'>
              <div className='input-wrapper flex items-center gap-3 relative cursor-pointer default-focus-element' 
                onClick={toggleGiftMessage} 
                onKeyDown={toggleGiftMessage} 
                role='checkbox'
                aria-checked={giftMessageChecked}
                tabIndex="0"
                aria-label={window.TMW.Strings.cart.giftMessage}
                >
                <input
                  className='input-checkbox--outline'
                  type='checkbox'
                  name='gift_message'
                  id='gift_message'
                  onChange={() => { }}
                  checked={giftMessageChecked}
                  tabIndex="-1"
                />
                <label
                  htmlFor='gift_message'
                  className='paragraph-4 pt-0.5 !pl-6'
                >
                  <span className='paragraph-4'>
                    {window.TMW.Strings.cart.giftMessage}
                  </span>
                </label>
                <Icon name="icon-check" customClasses='absolute w-2.5' />
              </div>
              <div className='relative'>
                <textarea
                  type="textarea"
                  id="gift_message_text"
                  name="gift_message_text"
                  className={`${giftMessageError ? 'border-error': 'border-grey-3'} p-3 paragraph-5 border  min-h-[195px] w-full`}
                  placeholder="Enter your gift message here. Please only use letters and numbers."
                  value={giftMessage}
                  onInput={handleGiftMessageChange}
                  onClick={(e) => e.stopPropagation()}
                  maxLength="300"
                  tabIndex="0"
                />
                <span className='absolute right-3 bottom-3 paragraph-5 text-grey-5'>
                  {300 - giftMessage.length}
                  {window.TMW.Strings.cart.giftCharacters}
                </span>
                { giftMessageError && <div className='absolute left-0 bottom-[-16px] text-error text-11'>{window.TMW.Strings.cart.giftMessageError}</div> }
              </div>
            </div>
          }
          {activeProduct?.allowGiftWrap?.value === '1' &&
            <div className={`flex flex-col gap-4 ${activeProduct?.allowGiftMessage?.value === '1' && 'pt-6'}`}>
              <div className='input-wrapper flex gap-3 items-center relative cursor-pointer' onClick={toggleGiftWrapping}
                onKeyDown={toggleGiftWrapping}
                role='checkbox'
                aria-checked={giftWrappingChecked}
                tabIndex="0"
                aria-label={`${giftWrappingProduct.title} - ${formatMoney({
                  amount: giftWrappingProduct.amount,
                  currencyCode: window.TMW?.localization?.currencyCode || 'USD',
                })}`}
                >
                <input
                  type="checkbox"
                  id="gift_wrapping"
                  name="gift_wrapping"
                  className='input-checkbox--outline'
                  onChange={() => { }}
                  checked={giftWrappingChecked}
                  tabIndex="-1"
                />
                <label htmlFor="gift_message" className='paragraph-4 pt-0.5 !pl-6'>
                  <span className='paragraph-4'>
                    {giftWrappingProduct.title} - {formatMoney({
                      amount: giftWrappingProduct.amount,
                      currencyCode: window.TMW?.localization?.currencyCode || 'USD',
                    })}
                  </span>
                </label>
                <Icon name="icon-check" customClasses='absolute w-2.5' />
              </div>
              <Image
                classes="h-auto w-[335px] aspect-[335/182]"
                src={giftWrappingProduct.image}
                srcWidths={{ sm: 350, md: 350, lg: 350, xl: 350, '2xl': 350 }}
              />
            </div>
          }
        </div>
        <div className="fixed w-full bottom-0 flex flex-col gap-4 border-t border-grey-3 p-5">
          <button
            className="justify-center w-full no-underline button button--dark"
            type="button"
            data-button-apply
            onClick={handleApplyClick}
            disabled={giftMessageError}
            tabIndex="0"
            ref={applyButtonRef}
          >
            {window.TMW.Strings.cart.giftApply}
          </button>
        </div>
        </div>
      </div>
    </Panel>
  );
};

export default withCartContext(Gift);
